import {
  Accessibility,
  Archive,
  Coins,
  Compass,
  Eye,
  Flame,
  Gavel,
  HardHat,
  Heart,
  Lightbulb,
  MessageCircle,
  Microscope,
  Minimize2,
  Network,
  Scale,
  Settings2,
  Shield,
  ShieldAlert,
  Timer,
  TrendingUp,
  Users,
  Workflow,
  Wrench,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";
import type { AgentRole } from "../../domain/types";

// İş Kolu A5 — "Crosshair"/"Swords" ikonları ve "Operasyonel Komutan"
// etiketi askeri çağrışım taşıyordu; savunma-dışı bir tartışmada
// (örn. sağlık, eğitim) bu ikonlar bağlamsal olarak yanlış/tuhaf
// kaçıyordu. Domain-nötr ikonlarla değiştirildi.
const MAP: Record<AgentRole, LucideIcon> = {
  moderator: Gavel,
  "strategic-visionary": Eye,
  "technical-authority": Wrench,
  "threat-analyst": Shield,
  contrarian: Flame,
  "operational-commander": Settings2,
  "compliance-officer": Scale,
  "pragmatic-architect": HardHat,
  "risk-officer": ShieldAlert,
  innovator: Lightbulb,
  "devils-advocate": Compass,
  "ux-advocate": Accessibility,
  "ethics-steward": Heart,
  "financial-steward": Coins,
  "people-advocate": Users,
  "customer-voice": MessageCircle,
  "evidence-auditor": Microscope,
  "tempo-strategist": Timer,
  simplifier: Minimize2,
  "scale-planner": TrendingUp,
  "stakeholder-navigator": Network,
  "institutional-memory": Archive,
  "systems-thinker": Workflow,
};

const LABEL: Record<AgentRole, string> = {
  moderator: "Moderatör",
  "strategic-visionary": "Stratejik Vizyoner",
  "technical-authority": "Teknik Otorite",
  "threat-analyst": "Tehdit ve Risk Analisti",
  contrarian: "Muhalif Ses",
  "operational-commander": "Operasyonel Yönetici",
  "compliance-officer": "Uyum ve Regülasyon",
  "pragmatic-architect": "Pragmatik Mimar",
  "risk-officer": "Risk Sorumlusu",
  innovator: "Yenilikçi",
  "devils-advocate": "Şeytan'ın Avukatı",
  "ux-advocate": "Kullanıcı Savunucusu",
  "ethics-steward": "Etik Sorumlusu",
  "financial-steward": "Finansal Denetçi",
  "people-advocate": "İnsan ve Ekip",
  "customer-voice": "Müşteri Sesi",
  "evidence-auditor": "Kanıt Denetçisi",
  "tempo-strategist": "Zamanlama Stratejisti",
  simplifier: "Sadeleştirici",
  "scale-planner": "Ölçek Planlayıcı",
  "stakeholder-navigator": "Paydaş Navigatörü",
  "institutional-memory": "Kurumsal Hafıza",
  "systems-thinker": "Sistem Düşünürü",
};

export function roleLabel(role: AgentRole): string {
  return LABEL[role];
}

interface RoleIconProps extends LucideProps {
  role: AgentRole;
}

export function RoleIcon({ role, ...rest }: RoleIconProps) {
  const Icon = MAP[role];
  return <Icon {...rest} />;
}
